import { EPageTypeGetParam } from '@/enums/EPageTypeGetParam';
import { UTILS__url } from '@/utils/UTILS__url';
import { DTO__grid2d } from '@shared/dto/grid2d/DTO__grid2d';
import { MutableRefObject, useRef } from 'react';
import { use_effect } from '../../../../hooks/_base/use_effect';

export function HOOK_GRID2D__slug_offset(grid2d: DTO__grid2d, ref_first_image_index_on_page: MutableRefObject<number>) {
  const slug_offset = useRef(0);

  set_slug_offset_from_url();

  /*
   * EFFECTS
   */

  use_effect(() => {
    if (grid2d.is_stub()) return;

    set_slug_offset_from_url();
  }, [grid2d, grid2d.total_cells_amount]);

  /*
   * METHODS
   */

  function set_slug_offset_from_url() {
    if (grid2d.is_stub()) return;

    let offset = Number(UTILS__url.get(EPageTypeGetParam.GRID2D_OFFSET));

    if (!Number.isSafeInteger(offset)) offset = 0;

    if (offset === slug_offset.current) return;

    ref_first_image_index_on_page.current = offset;
    set_slug_offset(offset);
  }

  function set_slug_offset(value: number) {
    if (grid2d.is_stub()) return;

    value = Math.min(value, grid2d.total_cells_amount - 1);
    value = Math.max(value, 0);

    slug_offset.current = value;
  }

  return { slug_offset: slug_offset.current, set_slug_offset, set_slug_offset_from_url };
}
